import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-opening-hours-support',
  templateUrl: './opening-hours-support.component.html',
  styleUrls: ['./opening-hours-support.component.scss']
})
export class OpeningHoursSupportComponent implements OnInit {

  @Input() public showContactPageLink: boolean;
  
  public router: Router;
  public currentDay: string;

  constructor(router: Router) 
  {
    this.router = router;
  }

  public ngOnInit(): void 
  {
    this.getCurrentDay();
  }

  public showPage(path: string): void
  {
    this.router.navigateByUrl(path);
  }

  public getCurrentDay(): string
  {
    const today = new Date().getDay();

    switch (today)
    {
      case 1:
        return this.currentDay = 'Monday';
      case 2:
        return this.currentDay = 'Tuesday';
      case 3:
        return this.currentDay = 'Wednesday';
      case 4:
        return this.currentDay = 'Thursday';
      case 5:
        return this.currentDay = 'Friday';
      case 6:
        return this.currentDay = 'Saturday';
      case 0:
        return this.currentDay = 'Sunday';
    }
  }
}
